// Socket.IO configuration for both development and production
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || (
    process.env.NODE_ENV === 'production'
        ? window.location.origin  // Use same origin in production
        : 'http://localhost:5000'  // For local development
);

export const BASE_URL = process.env.REACT_APP_API_URL || (
    process.env.NODE_ENV === 'production'
        ? '/api'
        : 'http://localhost:5000/api'
);
